export const SEX_LABELS: Record<string, string> = {
  male: "Samiec",
  female: "Samica",
};

export const PROGRAM_STATUS_LABELS: Record<string, string> = {
  unspecified: "Nie określono",
  no_license: "Brak licencji",
  license: "Licencja",
  in_program: "W programie",
};

export const ANIMAL_STATUS_LABELS: Record<string, string> = {
  active: "Aktywne",
  dead: "Padło",
  sold: "Sprzedane",
  slaughtered: "Ubój",
};

export const ALL_PROGRAM_STATUSES = [
  "unspecified",
  "no_license",
  "license",
  "in_program",
] as const;

export function normalizeTag(value: string): string {
  return String(value).toUpperCase().replace(/ +/g, " ").trim();
}

export function formatMoney(value: string | number | null | undefined): string {
  const num = Number(value ?? 0);
  return `${num.toLocaleString("pl-PL", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} zł`;
}

export function formatDate(value: string | null | undefined): string {
  if (!value) {
    return "—";
  }
  const iso = value.slice(0, 10);
  const parts = iso.split("-");
  if (parts.length === 3 && parts[0].length === 4) {
    return `${parts[2]}.${parts[1]}.${parts[0]}`;
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }
  return parsed.toLocaleDateString("pl-PL");
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) {
    return "—";
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return formatDate(value);
  }
  return parsed.toLocaleString("pl-PL", {
    dateStyle: "short",
    timeStyle: "short",
  });
}

export function todayIso(): string {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}
